import { Pipe, PipeTransform } from '@angular/core';
import { SystemBannerType } from '../../../../models/shared/system-banner';

@Pipe({
  name: 'systemBannerIcon',
  standalone: true
})
export class SystemBannerIconPipe implements PipeTransform {
  private iconMap: Record<SystemBannerType, string> = {
    error: 'assets/icons/red/ExclamationCircle.svg',
    info: 'assets/icons/dark/circle-i.svg',
    success: 'assets/icons/green/CheckCircleDarkGreen.svg',
    warning: 'assets/icons/dark/Exclamation Circle.svg'
  };
  transform(value: SystemBannerType): string {
    return this.iconMap[value];
  }
}
